<template>
  <div class="row">
    <div class="mc-readonly col" v-for="(item, idx) in items" :key="idx">
      <div class="__label">{{ item.label }}</div>
      <div :class="`__value${item.bold ? '-bold' : ''}`">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['items'],
}
</script>

<style lang="scss">
// Techdebt: refactor the hex color as new SCSS variables
.mc-readonly {
  margin: 4px;

  .__label {
    // Secondary/Navy/Navy 40
    color: $mep-color-text-200;
    margin-bottom: 0.5rem;
  }

  // color: $secondary;
  .__value {
    // Secondary/Navy/Navy 60
    color: $mep-color-text-300;
  }
  .__value-bold {
    // Secondary/Navy/Navy 80
    color: $mep-color-text-400;
    font-weight: 600;
  }
}
</style>
